
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shorts",
      function () {
        return require("private-next-pages/shorts/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shorts"])
      });
    }
  